// src/shared/components/ReportExportActions.tsx
import React, { useState } from "react";
import { Button, Menu, MenuItem } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { ReactComponent as ExportIcon } from "../../../assets/icons/export-report-icon.svg";
import {
  downloadCSV,
  exportToPDF,
  triggerPrint,
} from "../../utils/exportUtils";
import { LoadingButton } from "@mui/lab";

interface ExportActionsProps {
  filename: string;
  csvHeaders: string[];
  csvData: any[][];
  componentRef: React.RefObject<HTMLDivElement>;
  loading?: boolean;
}

export const ReportExportActions = ({
  filename,
  csvHeaders,
  csvData,
  componentRef,
  loading = false,
}: ExportActionsProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleExportCSV = () => {
    setAnchorEl(null);
    downloadCSV(filename, csvHeaders, csvData);
  };

  const handleExportPDF = () => {
    setAnchorEl(null);

    // Choice A: Use the Browser Print Dialog (Uses @media print CSS)
    // triggerPrint();

    // Choice B: Generate a PDF file directly from the HTML
    exportToPDF(componentRef.current, filename);
  };

  return (
    <>
      <LoadingButton
        variant="contained"
        className="btn-primary export-btn no-print"
        // endIcon={<KeyboardArrowDownIcon />}
        startIcon={<ExportIcon />}
        sx={{ textTransform: "none", bgcolor: "#2b2d42" }}
        onClick={(e) => setAnchorEl(e.currentTarget)}
        loading={loading}
      >
        Export Report
      </LoadingButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        className="export-menu"
      >
        <MenuItem onClick={handleExportPDF}>Export as PDF</MenuItem>
        <MenuItem onClick={handleExportCSV}>Export as CSV</MenuItem>
      </Menu>
    </>
  );
};
